import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function TransferSupplyWarningModal({
  show,
  onClose,
  onConfirm,
  positions
}) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Перенос позиций между поставками</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          Некоторые выбранные позиции уже относятся к другим поставкам.  
          Перемещение приведёт к тому, что эти позиции будут перенесены в выбранную поставку.
        </p>

        <p><b>Позиции в поставках:</b></p>
        <ul>
          {positions.map(p => (
            <li key={p.id}>
              {p.article} — поставка: {p.supply?.name || p.supply?.id}
            </li>
          ))}
        </ul>

        <p>Продолжить перенос?</p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Отмена</Button>
        <Button variant="primary" onClick={onConfirm}>Продолжить</Button>
      </Modal.Footer>
    </Modal>
  );
}
